<template>
  <!-- 公司简介 -->
  <div class="brief">
    <!-- banner -->
    <div class="banner">
      <img src="../../static/img/brief/jianjie.png" />

    </div>
    <!-- 简介 -->
    <div class="flex-center">
      <div class="content flex-between">
        <div class="left">
          <div class="title ml28">{{introduction.top_title}}</div>
          <div class="chinese ml28">{{introduction.next_title}}</div>
          <div class="line ml28"></div>
        </div>
        <div class="right">
          <div class="right_content"  v-html="introduction.content">
            <!-- {{introduction.content}} -->
          </div>
          <!-- <p>
            四川华顺源建设工程有限公司（简称四川华顺源）成立于2018年，是经建设厅核准的具有输变电工程专业承包三级资质；电力工程施工总承包三级；城市及道路照明工程专业承包三级；市政公用工程施工总承包三级资质。
          </p>
          <p>
            四川华顺源建设工程有限公司（简称四川华顺源）成立于2018年，是经建设厅核准的具有输变电工程专业承包三级资质；电力工程施工总承包三级；城市及道路照明工程专业承包三级；市政公用工程施工总承包三级资质。
          </p>
          <p>
            四川华顺源建设工程有限公司（简称四川华顺源）成立于2018年，是经建设厅核准的具有输变电工程专业承包三级资质；电力工程施工总承包三级；城市及道路照明工程专业承包三级；市政公用工程施工总承包三级资质。
          </p> -->
        </div>
      </div>
    </div>

    <!-- 办公环境 -->

    <div >
      <div class="titleImg flex-center" style="margin-top:80px;margin-bottom:50px">
        <img src="../../static/img/brief/env_title.png" alt />
      </div>
      <div class="environment flex-start">
        <div class="env_item" v-for="(item,index) in envList" :key="index"
          :style="{backgroundImage: 'url(' + item.img+')'}" style="background-size: 100% 100%;">
          <div class="mark">
            <div class="mark_text">{{item.name}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 资质 -->
    <div>
      <div class="titleImg flex-center" style="margin-top:80px;margin-bottom:50px">
        <img src="../../static/img/brief/zizhi_title.png" />
      </div>
      <!-- 证书 -->
      <div style="width: 100%;" class="flex">
        <div class="certificate flex-between-wrap">
          <div class="cer_item flex-column-between" v-for="(item,index) in certificateList" :key="index">
            <img :src="item.img" alt="">
            <div class="flex-center">
              <div class="name">{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 查看更多 -->
      <div class="flex-center">
        <div class="more3 mt50 mb190">查看更多 ></div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getBrief} from '../../api/apis.js'
  export default {
    name: "brief",
    data() {
      return {
        introduction:{},
        envList: [
          // {
          //   img: require("../../static/img/brief/bg1.png"),
          //   name: "安全稳定"
          // },
          // {
          //   img: require("../../static/img/brief/bg2.png"),
          //   name: "专业团队"
          // },
          // {
          //   img: require("../../static/img/brief/bg3.png"),
          //   name: "技术创新"
          // },
          // {
          //   img: require("../../static/img/brief/bg4.png"),
          //   name: "行业认证"
          // },
          // {
          //   img: require("../../static/img/brief/bg5.png"),
          //   name: "优质材料"
          // }
        ],
        certificateList: [
          // {
          //   img: require("../../static/img/brief/rongyu_1.png"),
          //   name: "荣誉名字"
          // },
          // {
          //   img: require("../../static/img/brief/rongyu_2.png"),
          //   name: "企业创新奖"
          // },
          // {
          //   img: require("../../static/img/brief/rongyu_3.png"),
          //   name: "资质证书"
          // },
          // {
          //   img: require("../../static/img/brief/rongyu_4.png"),
          //   name: "十佳诚信企业"
          // },
          // {
          //   img: require("../../static/img/brief/rongyu_5.png"),
          //   name: "荣誉名字"
          // },
          // {
          //   img: require("../../static/img/brief/rongyu_6.png"),
          //   name: "先进企业"
          // },
          // {
          //   img: require("../../static/img/brief/rongyu_7.png"),
          //   name: "资质证书"
          // },
          // {
          //   img: require("../../static/img/brief/rongyu_8.png"),
          //   name: "资质证书"
          // }
        ]

      };
    },
    components: {},

    methods: {
      initData(){
        getBrief().then(res => {
          this.introduction = res.introduction
          this.envList = res.office;
          this.certificateList = res.honor;
        })
      }
    },
    mounted() {
      this.initData();
    },
  };
  // 注册地址：四川省成都市武侯区星狮路711号1栋2单元11层1104号
  // 办公地址：四川省成都市武侯区星狮路711号1栋2单元11层1104号
</script>
<style scoped lang="scss">
  .banner {
    width: 100%;
  }

  .banner img {
    width: 100%;
  }
  .content {
    width: 1200px;
    height: 355px;

    .left {
      position: relative;
      width: 220px;
      height: 480px;
      background-image:url('../../static/img/brief/gunyu.png');
      margin-top:-125px;
      flex-shrink:0;
      color:#ffffff;
      .title{
        font-size: 32px;
        line-height: 42px;
        margin-top: 60px;
      }
      .chinese{
        margin-top: 20px;
        font-size:24px;
        padding-bottom: 24px;
      }
      .line{
        width:32px;
        height: 4px;
        background-color: #ffffff;
        margin-top:5px;
      }

    }

    .right {
      height: 308px;
      overflow: hidden;
      margin-top: 49px;
      margin-left: 49px;
      font-size: 16px;
      color: #333333;
      .right_content{
        line-height: 28px;
      }
      overflow: hidden;
    }
  }

  .environment {
    height: 574px;
    width: 100%;

  }

  .env_item {
    width: 20%;
    /* border: 1px solid #ccc; */
    height: 100%;

  }

  .env_item:hover {
    width: 640px;
    flex-shrink: 0;

    .mark {
      display: none;
    }

  }

  .mark {
    width: 100%;
    height: 100%;
    background-color: rgba(27, 91, 160, 0.4);
    position: relative;
  }

  .mark_text {
    position: absolute;
    width: 100%;
    height: 100px;
    top: 50%;
    margin-top: -50px;
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    color: #ffffff;
  }

  .certificate {
    width: 1200px;

    .cer_item {
      width: 260px;
      height: 220px;
      margin-bottom: 25px;

      img {
        height: 180px;
      }

      .name {
        height: 21px;
        margin-top: 16px;
        color: #333333;
        font-size: 16px;
      }
    }
  }

  .more3 {
    display: inline-block;
    padding: 10px 26px;
    color: #999999;
    font-size: 16px;
    border: 1px solid rgba(213, 213, 213, 1);
    border-radius: 4px;
    cursor:pointer;
  }
</style>